import type { ManualExpenseScope } from "./manualExpenses";

export const FINANCE_IMPORT_TEMPLATE_VERSION = "ODS_FINANCE_IMPORT_V1" as const;

export const FINANCE_IMPORT_TEMPLATE_SHEETS = [
  "Facturas y gastos",
  "Instrucciones",
  "Proveedores",
  "Instalaciones",
  "Categorías",
] as const;

export const FINANCE_IMPORT_BASE_COLUMNS = [
  "tipo",
  "proveedor_nombre",
  "proveedor_cif",
  "numero_factura",
  "fecha_factura",
  "fecha_vencimiento",
  "base_imponible",
  "iva",
  "total",
  "categoria",
  "instalacion",
  "imputacion",
  "descripcion",
  "referencia_externa",
] as const;

export type FinanceImportRowKind = "supplier_invoice" | "manual_expense" | "unknown";
export type FinanceImportIssueSeverity = "error" | "warning";

export type FinanceImportIssue = {
  severity: FinanceImportIssueSeverity;
  code: string;
  message: string;
  rowNumber?: number;
  column?: string;
};

export type FinanceImportPreviewRow = {
  rowNumber: number;
  kind: FinanceImportRowKind;
  canImportLater: boolean;
  destinationScope: ManualExpenseScope;
  installationId: number | null;
  installationReference: {
    id: number;
    installationCode?: string | null;
    expedienteCode: string | null;
    clientName: string | null;
    siteName?: string | null;
    workDescription: string | null;
    address: string | null;
    status: string | null;
  } | null;
  supplierId: number | null;
  supplierName: string | null;
  supplierTaxId: string | null;
  supplierIsPending: boolean;
  supplierCreateKey: string | null;
  supplierDraft: { name: string; taxId: string | null } | null;
  categoryId: number | null;
  categoryCode: string | null;
  categoryName: string | null;
  invoiceNumber: string | null;
  invoiceDate: string | null;
  dueDate: string | null;
  taxableBaseCents: number | null;
  vatRate: number | null;
  vatAmountCents: number | null;
  totalAmountCents: number | null;
  description: string | null;
  externalReference: string | null;
  duplicateKey: string | null;
  issues: FinanceImportIssue[];
};

export type FinanceImportPreviewSummary = {
  totalRows: number;
  validRows: number;
  blockedRows: number;
  warningRows: number;
  supplierInvoiceRows: number;
  manualExpenseRows: number;
  byDestination: Record<ManualExpenseScope, number>;
};

export type FinanceImportPreviewResult = {
  fileName: string;
  sheetName: string | null;
  previewOnly: true;
  rows: FinanceImportPreviewRow[];
  summary: FinanceImportPreviewSummary;
  issues: FinanceImportIssue[];
};

export type FinanceImportCommitResult = {
  batchId: number;
  fileName: string;
  fileHash: string;
  committedRows: number;
  skippedRows: number;
  created: Array<{
    rowNumber: number;
    sourceType: "supplier_invoice" | "manual_expense";
    sourceId: number;
  }>;
};

export const FINANCE_IMPORT_DESTINATION_LABELS: Record<ManualExpenseScope, string> = {
  installation: "Instalación / expediente",
  warehouse: "Almacén",
  general_overhead: "Gastos generales",
  unallocated: "Pendiente de imputar",
};

export function isFormulaLikeImportValue(value: unknown): boolean {
  return typeof value === "string" && /^[=+\-@]/.test(value.trim());
}
